// Schmaler Wrapper um fetch. Alle Antworten des Backends sind JSON, Fehler
// tragen ein Feld `fehler` — das packen wir in eine Exception, damit die
// Aufrufer nur try/catch brauchen.

export async function api(pfad, { methode = 'GET', koerper } = {}) {
  const antwort = await fetch(`/api${pfad}`, {
    method: methode,
    credentials: 'same-origin',
    headers: koerper ? { 'Content-Type': 'application/json' } : undefined,
    body: koerper ? JSON.stringify(koerper) : undefined,
  })

  let daten = null
  try {
    daten = await antwort.json()
  } catch {
    // Antwort ohne Rumpf — bleibt null.
  }

  if (!antwort.ok) {
    const fehler = new Error(daten?.fehler || `Serverfehler (HTTP ${antwort.status})`)
    fehler.status = antwort.status
    throw fehler
  }

  return daten
}
